// extracted by mini-css-extract-plugin
module.exports = {"empty":"stocks_empty__23KOy","text":"stocks_text__wCm3y","button":"stocks_button__2IjhX","page":"stocks_page__30Va-","table":"stocks_table__1zYcl"};